// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"775be900","513":"9656bb5e"}[chunkId] + ".chunk.js";
};